import { colorAccent1, colorInfo } from '@atlas-frontend/design-tokens';
import {
  DataObjectGroupProcessingStateType,
  SystemClassifierItemDto,
  Tooltip,
} from '@atlas-frontend/sdk';
import { Button, Flex } from 'antd';
import { useMemo } from 'react';
import * as Icon from 'react-feather';
import { path } from '../../paths';
import { UiLink } from '../../paths/UiLink';

export const ErrorLevel: React.FC<{
  processingState: DataObjectGroupProcessingStateType;
  processingErrorLevels: SystemClassifierItemDto[];
  processingTypes: SystemClassifierItemDto[];
  processingStatuses: SystemClassifierItemDto[];
}> = ({
  processingState,
  processingErrorLevels,
  processingTypes,
  processingStatuses,
}) => {
  const { loadSampleErrorLevelId, imputeErrorLevelId, loadDataErrorLevelId } =
    processingState;

  const typesWithAnyErrorLevel = useMemo(
    () =>
      [
        ['LOAD_SAMPLE', loadSampleErrorLevelId],
        ['IMPUTE_DATA', imputeErrorLevelId],
        ['LOAD_DATA', loadDataErrorLevelId],
      ]
        .map(([typeCode, levelId]) => [
          processingTypes.find((type) => type.code === typeCode),
          processingErrorLevels.find((level) => level.id === levelId),
        ])
        .filter(([type, level]) => type && level),
    [
      imputeErrorLevelId,
      loadDataErrorLevelId,
      loadSampleErrorLevelId,
      processingErrorLevels,
      processingTypes,
    ],
  );

  const { valueDate, dataObjectGroupId, standaloneDataObjectDescriptionId } =
    processingState;

  if (typesWithAnyErrorLevel.length === 0) {
    return null;
  }

  const typesWithErrors = typesWithAnyErrorLevel.filter(
    ([, level]) => level?.code === 'ERROR',
  );

  return (
    <Flex>
      <Tooltip
        title={(typesWithErrors.length > 0
          ? typesWithErrors
          : typesWithAnyErrorLevel
        )
          .map(([type]) => type?.name)
          .join(', ')}
        placement="bottom-start"
      >
        <UiLink
          id={`errors-${processingState.id}`}
          path={path.inputDataErrorDirectory}
          params={{
            valueDate: [valueDate, valueDate].join(','),
            dataObjectId:
              standaloneDataObjectDescriptionId || dataObjectGroupId || '',
            dataObjectType: standaloneDataObjectDescriptionId
              ? 'description'
              : 'group',
            statusId:
              processingStatuses.find((status) => status.code === 'PENDING')
                ?.id ?? '',
          }}
        >
          {({ type, ...props }) => (
            <Button
              {...props}
              size="small"
              shape="circle"
              icon={
                <Icon.AlertTriangle
                  size={18}
                  color={typesWithErrors.length > 0 ? colorAccent1 : colorInfo}
                />
              }
            />
          )}
        </UiLink>
      </Tooltip>
    </Flex>
  );
};
